<template>

  <v-btn
    class="zoom-hover"
    v-bind="computedProps"
    v-on="computedListeners">
    <slot></slot>
  </v-btn>

</template>
<script>
/**
 * @file DDv2用標準ボタン
 * @namespace components
 */

/**
 * @vue-event {Object} click
 * @see https://vuetifyjs.com/ja/api/v-btn/
 * @example
<dd-default-button
  [atmark]click="DbDefaultButtonOnClick">
  検索
</dd-default-button>
 */
export default {
  name: 'DdDefaultButton',
  props: {
  },
  data: () => ({
  }),
  computed: {
    computedProps () {
      return {
        ...this.$props,
        dark: true,
        dense: true,
        color: '#2196F3',
        minWidth: 80
      }
    },
    computedListeners () {
      return {
        ...this.$listeners
      }
    }
  },
  mounted: function () {
  },
  methods: {
  }
}
</script>
<style scoped>
i::before {
  color: #1976d2 !important;
}
</style>
